import { render, staticRenderFns } from "./MovimentacaoListagemTabela.vue?vue&type=template&id=5511f761&"
import script from "./MovimentacaoListagemTabela.vue?vue&type=script&lang=js&"
export * from "./MovimentacaoListagemTabela.vue?vue&type=script&lang=js&"
import style0 from "./MovimentacaoListagemTabela.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VIcon,VPagination,VSelect,VSpacer})
